import React, { useEffect, useState, useMemo, useRef } from 'react'
import CommonSelect from './commonSelect';


import { useNavigate } from 'react-router'
import { formFieldDataP3 } from '../../../../core/data/json/DistrictAPMC';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SingleView from './SingleView';
import { Link } from 'react-router-dom';
import { getApmcPurposes, getExistedSchemesAplication, queryFormApplication, submitAnnexureUpdate, submitApmcApproveRejectApplication, updateField } from '../../../auth/services/privateapicalling';
import {  DistrictJCandCOM } from './DistrictApplication';
import ActionButtons from './ActionButtons';
import { toast } from 'react-toastify';
import ApplicationTimelineModal from '../../LandDistrict/components/ApplicationTimeLineModal';
import { roleOptions } from '../../../../core/data/json/role';

interface APMCp3Props {
  setExistData:any,
  onBack: () => void;
  formData: any;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement> , documentName: string) =>Promise<string>;
  transaction:any[];
  hanldeFileInputChange: (e: React.ChangeEvent<HTMLInputElement> , documentName: string) => void;
  handleInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleEdInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handlePreviewFile: (fileData:any)=>void;
  editingIndex: number | null;
  setEditingIndex: (index: number | null) => void;
  editFieldValues: { [key: string]: any };
  handleEditChange: (name: string, value: any) => void;
  editFiles: { [key: string]: File | null };
  handleEditFileChange: (name: string, file: File | null) => void;
  editComment: string;
  setEditComment: (comment: string) => void;
  updatedFields:any;
  setUpdatedFields:any;
  existData:any;
  userDetail:any
  token:any;
  siteInspectionPhotos:any[]
  applicationId:any;
  getExistedApplication :() => void;
  assistanceDetails: {
      date: string;
      scheme: string;
      purpose: string;
      sanctionedAmount: string;
      totalAmount: string;
      hasExceeded5Crore: string
    }[];
inspectionPhotosChange:(e: React.ChangeEvent<HTMLInputElement> , fieldName:string)=>void;
    setAssistanceDetails: React.Dispatch<React.SetStateAction<{
      date: string;
      scheme: string;
      purpose: string;
      sanctionedAmount: string;
      totalAmount: string;
      hasExceeded5Crore: string
  }[]>>;
  
  validationErrors: { [key: string]: boolean };
  setValidationErrors: (errors: { [key: string]: boolean } | ((prev: { [key: string]: boolean }) => { [key: string]: boolean })) => void;
  isValidationActive: boolean;
  setIsValidationActive: (active: boolean) => void;
}

const DistP3 = ({
  setExistData,
siteInspectionPhotos,
  token,
  onBack,
  formData,
  handleFileChange,
  handleInputChange,
  handlePreviewFile,
  handleEdInputChange,
  inspectionPhotosChange,
  hanldeFileInputChange,
  editingIndex,
  setEditingIndex,
  editFieldValues,
  handleEditChange,
  editFiles,
  handleEditFileChange,
  editComment,
  setEditComment,
  transaction,
  // handleUpdateSubmit,  
  assistanceDetails,
  setAssistanceDetails,
   updatedFields,
   setUpdatedFields,
  existData,
  userDetail,
  applicationId,
  getExistedApplication,
  validationErrors,
  setValidationErrors,
  isValidationActive,
  setIsValidationActive,

}: APMCp3Props) => {


//----------------------------------Field Open Logic----------------------------------
  


  const [logFieldKey, setLogFieldKey] = useState<string | null>(null);
  const [centralComment,setCentralComment]=useState<string>("");

  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  
  const [showLogOverlay, setShowLogOverlay] = useState(false);
    const [transactionData, setTransactionData] = useState([]);

  // Compute total sanctioned amount across all assistance details
  const totalSanctionedAmount = useMemo(() => {
    if (!assistanceDetails || !Array.isArray(assistanceDetails)) return 0;
    return assistanceDetails.reduce((sum: number, block: any) => {
      const raw = (block?.sanctionedAmount ?? "").toString().replace(/[^0-9.\-]/g, "");
      const n = parseFloat(raw);
      return sum + (isNaN(n) ? 0 : n);
    }, 0);
  }, [assistanceDetails]);

  const formattedTotalSanctioned = totalSanctionedAmount > 0 ? totalSanctionedAmount.toLocaleString('en-IN') : "";
  
const [issued,setIssued]= useState(false);

   const scheme =[{
  label: existData?.scheme?.name,
  value: existData?.scheme?.name
 }]
const handleViewLogClick = (fieldKeys: string[] | string) => {
 
   const keys = Array.isArray(fieldKeys) ? fieldKeys : [fieldKeys];
   
    
    const transactionData = keys.map(key => ({
      key,
      data: existData.annexureThree?.[key]?.transaction || []
    }));

    setTransactionData(transactionData)

    setLogFieldKey(keys.join(", "));
  setShowLogOverlay(true);
};


  const [fieldActions, setFieldActions] = useState<{ [key: number]: {
    verified: boolean;
    updated: boolean;
    comment: string;
    updateData: any;
    submitted?: boolean;
  } }>({});
  const handleCloseOverlay = () => {
    setShowLogOverlay(false);
  };
  const roleIdentifier = userDetail.Role.Role_Identifier;

 

useEffect(() => {
  if (roleIdentifier === "Dr"||roleIdentifier === "SC" || roleIdentifier === "HOS" || roleIdentifier === "DT" || roleIdentifier === "DY" ||roleIdentifier==="SA") {
    setIssued(true);
  
    setCertificateData(prevData => ({
      ...prevData,
      FilledFormName: existData?.FilledFormName || "",
      positionName: existData?.positionName || "",
      projectCapability: existData?.projectCapability || ""
    }));

  }
}, [roleIdentifier]);

  const navigate = useNavigate();

 const[purposes, setPurposes] = useState<any[]>([]);

  //---------------------------------Validation----------------------------------

const [agreeTermsCOM, setAgreeTermsCOM] = useState(false);
const [agreeErrorCOM, setAgreeErrorCOM] = useState(false);


const validateActionButtons = () => {
  const errors: { [key: string]: boolean } = {};
  
  // Check each field that requires action
  formFieldDataP3.forEach((item, index) => {
    // Skip fields that don't need validation based on role
 

    // Also check if role is allowed for this field
    if (!item.roles.includes(roleIdentifier)) {
      return;
    }

    const fieldAction = fieldActions[index];
    const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;


// Check if field was already submitted in existData
let isFieldSubmittedInExistData = false;

item.response.forEach((r) => {
  const reSubmittedFieldsData = existData?.apmcSchemeTransaction?.rejectedFields?.rejectedFieldsData?.annexureThree;
  const transactions = existData.annexureThree?.[r.fieldName]?.transaction || [];
  let lastRoleTx = null;
 const shouldCheckResubmission = existData?.appStatusLevel !== 'pendingAtHigherAuthorityApproval';
  if (shouldCheckResubmission && reSubmittedFieldsData && Object.prototype.hasOwnProperty.call(reSubmittedFieldsData, r.fieldName)) {
    // If resubmitted field, only set lastRoleTx if the last transaction is for this role
    if (transactions.length > 0) {
      const lastTx = transactions[transactions.length - 1];
      if (lastTx.transactionBy === roleIdentifier) {
        lastRoleTx = lastTx;
      }
    }
  } else {
    // Not a resubmitted field: filter by role as before
    lastRoleTx = transactions.filter(
      (tx) => tx.transactionBy === roleIdentifier
    ).pop();
  }

  if (lastRoleTx) {
    if (lastRoleTx.isVerified === true || 
        lastRoleTx.isUpdated === true || 
        (lastRoleTx.comment && lastRoleTx.comment.trim() !== '')) {
      isFieldSubmittedInExistData = true;
    }
  }
});
    // Field has error if it's not submitted and has no current action
    if (!isFieldSubmittedInExistData && !fieldAction?.submitted) {
      errors[`field_${index}`] = true;
    }
  });

  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
};
  // ---------------------Verified Check---------------------







    const [touched, setTouched] = useState<{ [key: string]: boolean }>({});


//--------------------------------Validation logic for each field--------------------------------
  
const getpurpose=async(scheme)=>{
  try{
        const resp= await getApmcPurposes(scheme)
    const rawPurposes = resp?.data.map((item: any) => ({
      label: item.subName,
      value: item.subName,
    }));
    setPurposes(rawPurposes);
  
    
    // setPurposes(rawPurposes)
      }catch(error){
   
      }
}
 



type AssistanceField = 'dateField' | 'scheme2' | 'purpose2' | 'sanctionedAmount';




const handleAssistanceChange = (index: number, field: string, value: string) => {
  setAssistanceDetails(prev => {
    const updated = [...prev];
    updated[index] = {
      ...updated[index],
      [field]: value
    };
    
    return updated;
  });
};
  

const addAssistanceBlock = () => {
  if (assistanceDetails .length < 6) {
    setAssistanceDetails ([
      ...assistanceDetails ,
      { date: "", scheme: "", purpose: "", sanctionedAmount: "" , totalAmount:"", hasExceeded5Crore:""}
    ]);
  }
};

const removeAssistanceBlock = (index: number) => {
  const updated = assistanceDetails .filter((_, i) => i !== index);
  setAssistanceDetails (updated);
};

  //----------------------Input Functions------------------------
const radioFn = (fieldName: string) => (
  
  <div className="d-flex justify-start gap-2 w-75">
    <input
      type="radio"
      name={fieldName}
      value="yes"
      checked={formData[fieldName] === "yes"}
      onChange={handleInputChange}
      disabled={true}
    />{" "}Yes
    <input
      type="radio"
      name={fieldName}
      value="no"
      checked={formData[fieldName] === "no"}
      onChange={handleInputChange}
      disabled={true}
    />{" "}No
  </div>
);

const inputFn =(fieldName: string)=>{
  return(
      <input
      type='text'
      className=" p-2 w-75 form-control"
      placeholder={`Enter ${fieldName}`}
      name={fieldName}
      value={formData[fieldName] || ""}
      onChange={handleInputChange}
      onBlur={handleBlur}
      disabled={ true}
      />
  )
}

const edInputFn =(fieldName: string)=>{
  return(
      <input
      type='text'
      className=" p-2 w-75 form-control"
      placeholder={`Enter ${fieldName}`}
      name={fieldName}
      value={formData[fieldName] || ""}
      onBlur={handleBlur}
      onChange={handleEdInputChange}
      />
  )
}


const fileFn = (response:any) => (
  <>
    <input
      className="form-control"
      type="file"
      onChange={(e) => {
        hanldeFileInputChange(e, response);
      }}
      name={response}
      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
      id={response}
    />

    {/* Prevent long filenames from overflowing: truncate with ellipsis */}
    {formData[response] && (
      <div className="w-100" style={{ overflow: 'hidden' }}>
        <p
          className="mb-0"
          style={{
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={formData[response]?.fileName}
        >
          Uploaded: {formData[response]?.fileName}
        </p>
      </div>
    )}
  </>
);

const fileButtonFn = (fieldName , docName) => {

  const docData = existData?.annexureThree?.[fieldName];
  // Defensive lookup: backend may use different keys (documentName, docName, etc.).
  const docId = docData?.data?.find((d: any) => {
    if (!d) return false;
    const nameCandidate = d?.documentName ?? d?.docName ?? d?.docname ?? d?.doc ?? "";
    return String(nameCandidate).trim() === String(docName).trim();
  })?.docId;

  const hasValidDocId = docId !== null && docId !== undefined && String(docId).trim() !== "";

  return (
    hasValidDocId &&
    <Link
    to="#"
    key={docId}
    data-bs-toggle="modal"
    data-inert={true}
    data-bs-target="#apmc_modal"
    className="btn btn-outline-info w-75 align-items-center"
    onClick={() => {
      setSelectedDocId(docId);
   
    }}
  >
    <i className="ti ti-eye"></i> View Document
  </Link>
  );
};

   const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
      setTouched(prev => ({ ...prev, [e.target.name]: true }));
    };
   const[certificateData,setCertificateData]= useState({
      positionName:existData?.positionName ||"",
      FilledFormName:existData?.FilledFormName ||"",
      projectCapability:existData?.projectCapability ||""
    })
  const [certificateErrors, setCertificateErrors] = useState<{ positionName?: string; FilledFormName?: string; projectCapability?: string }>({});


// )------------------------------BUTTONS FOR ACTIONS (verify, edit, comment)------------------------------
  const handleVerifiedChange = (fieldIndex: number) => {
    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: !prev[fieldIndex]?.verified,
        updated: prev[fieldIndex]?.updated || false,
        comment: prev[fieldIndex]?.comment || "",
        updateData: prev[fieldIndex]?.updateData || {},
        submitted: prev[fieldIndex]?.submitted || false 
      }
    }));
  };

  const handleCommentChange = (fieldIndex: number, comment: string) => {
   
    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: prev[fieldIndex]?.verified || false,
        updated: prev[fieldIndex]?.updated || false,
        comment: comment,
        updateData: prev[fieldIndex]?.updateData || {}
      }
    }));
  };

  const handleUpdateData = (fieldIndex: number, updateData: any) => {
    // Only set updated to true if there's actual data in updateData
    const hasActualData = Object.values(updateData).some(value => 
      value !== null && value !== undefined && value !== ""
    );
    
    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: prev[fieldIndex]?.verified || false,
        updated: hasActualData,
        comment: prev[fieldIndex]?.comment || "",
        updateData: updateData,
        submitted: prev[fieldIndex]?.submitted || false
      }
    }));
  };
const [updatedFieldsStatus, setUpdatedFieldsStatus] = useState<{ [key: string]: boolean }>({});



 const tempgetExistedApplication = async () => {
     try {
         
          const response = await getExistedSchemesAplication(token, applicationId, existData.scheme.id);
         
          if (response?.success) {
          
             setExistData(response?.data);
          }
        } catch (error) {
        
        }
      }
 function buildResponseMap(jsonData) {
    return jsonData
      .flatMap(field => field.response)
      .reduce((acc, resp) => {
        acc[resp.responseVal] = resp.responseName;
        return acc;
      }, {});
  }
  const responseMap = buildResponseMap(formFieldDataP3);

// Updated handleUpdateSubmit function to mark field as updated
const handleUpdateSubmit = async (index: number, responses: any[]) => {


  responses.forEach((res: any) => {
    const searchKey = res.responseVal;
    // Update text-based values
    // Update files (if applicable)
  });

 const fieldAction = fieldActions[index];
     

    if (!fieldAction) {
     
      return;
    }

   
    const comment = fieldAction.comment;
  const oldValue: any[] = [];
  const newValue: any[] = [];
  let isFieldUpdated = false;
  const field = responses.find(res => res.fieldName).fieldName

  if(Object.keys(updatedFields).length > 0)
  {
    isFieldUpdated=true;
     // Handle regular field updates
  Object.entries(updatedFields).forEach(([fieldKey, updatedVal]: any) => {
    const fieldDataArray = existData?.annexureThree?.[field]?.data;

    
    if (!Array.isArray(fieldDataArray)) return;

    let matched;

    if (updatedVal?.docId && updatedVal?.documentName) {
      matched = fieldDataArray.find(
        (item: any) =>
          item?.documentName === updatedVal.documentName && item?.docId !== updatedVal.docId
      );

      if (matched) {
        oldValue.push({
          fieldValue: matched?.docId || "",
          fieldName: updatedVal.documentName,
             fileName: matched?.fileName,
          fieldType: "doc"
        });
      }
    } else {
      matched = fieldDataArray.find(
        (item: any) => item?.fieldName === fieldKey
      );

      if (matched) {
        oldValue.push({
          fieldValue: matched?.value || "",
          fieldName: fieldKey,
          fieldType: "string"
        });
      }
    }
  });

  // Handle new field updates

  Object.entries(updatedFields).forEach(([fieldKey, updatedVal]: any) => {
    if (updatedVal?.docId && updatedVal?.documentName) {
      newValue.push({
        fieldValue: updatedVal.docId,
        fieldName: updatedVal.documentName,
          fileName: updatedVal.fileName,
        fieldType: "doc"
      });
    } 
    else {
      newValue.push({
        fieldValue: updatedVal,
        fieldName: fieldKey,
        fieldType: "string"
      });
    }
  });
  }
 

 

    if(fieldAction?.comment.trim()=="" &&isFieldUpdated) 
      {
        toast.warn('comment is mandatory while updation',{position:"top-right"});
        return;
      }
  const transaction = [
    {
      oldValue,
      newValue,
      transactionBy: roleIdentifier,
      status: existData.status,
      appStatusLevel: existData.appStatusLevel
      
    }
  ];

  const payload = {
    couchId: existData?.applicationDataId,
    fieldUpdated: field,
     applicationType:"scheme",
     isUpdated:isFieldUpdated,
       isVerified: isFieldUpdated?false:fieldAction.verified,
      comment: comment,
    annexureUpdated: "annexureThree",
    [`${field}`]: {
      transaction
    },

  }



  const submitTransaction = await updateField(payload, token)
  

if (submitTransaction?.result?.ok) {
  // 🔥 NEW: Mark this field as updated
  const fieldNoFromIndex = formFieldDataP3[index]?.fieldNo;
  if (fieldNoFromIndex) {
    setUpdatedFieldsStatus(prev => ({
      ...prev,
      [fieldNoFromIndex]: true
    }));
  }
  
  setEditingIndex(null);
  setEditComment("");
   toast.success(
            <>
              Field Transaction submitted successfully <br />
              ફીલ્ડ સફળતાપૂર્વક સબમિટ કરવામાં આવ્યું
            </>,
            {
              position: "top-right",
          
            }
          );
  
  // Update the field action to mark as submitted instead of clearing it
  setFieldActions(prev => ({
    ...prev,
    [index]: {
      ...prev[index],
      submitted: true  // Add this flag to indicate submission is complete
    }
  }));
  
  // ADD THESE NEW LINES FOR VALIDATION
  // Clear validation error for this field
  setValidationErrors(prev => {
    const updated = { ...prev };
    delete updated[`field_${index}`];
    return updated;
  });
  
  setUpdatedFields({})
  tempgetExistedApplication();
  } else {
 
  }
};

  



const handleSubmit = async() => {

  // Validate checkbox for COM/Dr
  if ((roleIdentifier === "COM") && !agreeTermsCOM) {
    setAgreeErrorCOM(true);
    toast.error("You must agree before proceeding", { position: "top-right" });
    return;
  }

  if( roleIdentifier==="COM"&&(siteInspectionPhotos.length<4||Object.keys(siteInspectionPhotos).length < 4)&&existData?.appStatusLevel==="pendingAtCOM"){
    toast.error("Please upload at least 4 site inspection photos before proceeding", { position: "top-right" });
    return;
  }

  // Validate certificate data for roles that require issuance (Dr/SC/HOS/DT/DY)
 
    const errors: { positionName?: string; FilledFormName?: string; projectCapability?: string } = {};
  if(roleIdentifier==="COM")
    {  if (!certificateData.positionName || certificateData.positionName.trim() === "") {
      errors.positionName = "Position name is required.";
    }
    if (!certificateData.FilledFormName || certificateData.FilledFormName.trim() === "") {
      errors.FilledFormName = "Form name is required.";
    }}
    if (!certificateData.projectCapability || certificateData.projectCapability.trim() === "") {
      errors.projectCapability = "Project capability is required.";
    }

    if (Object.keys(errors).length > 0) {
      setCertificateErrors(errors);
      toast.error("Please fill required certificate details.", { position: "top-right" });
      return;
    } else {
      // clear previous errors
      setCertificateErrors({});
    }
  


    // First validate action buttons
    if(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"&&roleIdentifier===existData?.role&&existData?.appStatusLevel!=="hoclerkAfterApproveAction")
{  const isValid = validateActionButtons();
  setIsValidationActive(true);

  if (!isValid) {
    // Scroll to first error field
    const firstErrorField = Object.keys(validationErrors)[0];
    if (firstErrorField) {
      const fieldIndex = firstErrorField.replace('field_', '');
      const element = document.getElementById(`actionButtons_${fieldIndex}`);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }
    }
    
    toast.error("Please complete all required actions before proceeding", {
      position: "top-right"
    });
    return;
  }}

  // Reset validation state on successful validation
    setIsValidationActive(false);
    setValidationErrors({});



        if(roleIdentifier==="COM" )
        {      
            navigate('/districtRegistrar' , {state:{existData:existData , applicationId:applicationId,certificateData:certificateData,siteInspectionPhotos:siteInspectionPhotos}})

        }
        else if([ "Dr","SC","HOS","DT","DY","SA"].includes(roleIdentifier))
            navigate('/districtRegistrar' , {state:{existData:existData , applicationId:applicationId}})

    // navigate('/districtRegistrar' , {state:{existData:existData , applicationId:applicationId}})
    };
    
        const handleFinalSubmit = async (status: string, appStatusLevel: string) => {
          
if(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"&&roleIdentifier===existData?.role&&existData?.appStatusLevel!=="hoclerkAfterApproveAction")
  {      
     const isValid = validateActionButtons();
  setIsValidationActive(true);

  if (!isValid) {
    // Scroll to first error field
    const firstErrorField = Object.keys(validationErrors)[0];
    if (firstErrorField) {
      const fieldIndex = firstErrorField.replace('field_', '');
      const element = document.getElementById(`actionButtons_${fieldIndex}`);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }
    }
    
    toast.error("Please complete all required actions before proceeding", {
      position: "top-right"
    });
    return;
  }}

  // Reset validation state on successful validation
    setIsValidationActive(false);
    setValidationErrors({});
            
    
            try {
                const submitFormData = {
                    status: status,
                    appStatusLevel: appStatusLevel,
                    applicationId: applicationId,
                    comment:centralComment,
                    schemeId: existData?.scheme?.id,
                    applicationType: "scheme"
                };
    
              
    
                const submitData = await submitApmcApproveRejectApplication(submitFormData, token);
    
                if (submitData?.success) {
                    let successMessage = "";
                    if (submitData?.data?.status === "reject") {
                        successMessage = "Query raised successfully!";
                        toast.warning(successMessage, { position: "top-right" });
                    } else if (submitData?.data?.status === "permanentReject") {
                        successMessage = "Application permanently rejected!";
                        toast.error(successMessage, { position: "top-right" });
                    } else if (submitData?.data?.status === "approvedUnsigned") {
                        successMessage = "Application approved successfully!";
                        toast.success(successMessage, { position: "top-right" });
                    } else {
                        successMessage = "Form submitted successfully!";
                        toast.success(successMessage, { position: "top-right" });
                    }
    
                    setTimeout(() => {
                        navigate("/apmc-application");
                    }, 2000);
                } else {
                    toast.error(submitData?.message, {
                        position: "top-right"
                    });
                }
    
            } catch (error) {
              
                toast.error("An error occurred during submission.", {
                    position: "top-right"
                });
            }
        };
useEffect(() => {
  getpurpose(existData?.scheme?.name);
}, [existData?.scheme?.name]);
 useEffect(() => {
  
  
      if (!existData || !existData.annexureThree || !formFieldDataP3) return;
  
      const newVerified: { [key: number]: boolean } = {};
      const newUpdatedIndexes: number[] = [];
      const newComments: { [key: string]: string } = {};
  
      formFieldDataP3.forEach((item, index) => {
        let isVerifiedForRole = false;
        let isUpdatedForRole = false;
        let commentForRole: string | null = null;
  
        item.response.forEach((r) => {
          const reSubmittedFieldsData = existData?.apmcSchemeTransaction?.rejectedFields?.rejectedFieldsData?.annexureThree;
          const transactions = existData.annexureThree?.[r.fieldName]?.transaction || [];
          let lastRoleTx = null;
          const shouldCheckResubmission = existData?.appStatusLevel !== 'pendingAtHigherAuthorityApproval';
          if (shouldCheckResubmission&&reSubmittedFieldsData && Object.prototype.hasOwnProperty.call(reSubmittedFieldsData, r.fieldName)) {
            // If resubmitted field, only set lastRoleTx if the last transaction is for this role
            if (transactions.length > 0) {
              const lastTx = transactions[transactions.length - 1];
              if (lastTx.transactionBy === roleIdentifier) {
                lastRoleTx = lastTx;
              }
            }
          } else {
            // Not a resubmitted field: filter by role as before
            lastRoleTx = transactions.filter(
              (tx) => tx.transactionBy === roleIdentifier
            ).pop();
          }
  
          if (lastRoleTx) {
            if (lastRoleTx.isVerified === true) {
              isVerifiedForRole = true;
            }
            if (lastRoleTx.isUpdated === true) {
              isUpdatedForRole = true;
            }
         if (lastRoleTx.comment) {
  const shouldAssignComment = 
    existData.appStatusLevel === "pendingAtHigherAuthorityLevel"
      ? lastRoleTx.appStatusLevel === "pendingAtHigherAuthorityLevel"
      : true;
  
  if (shouldAssignComment) {
    commentForRole = lastRoleTx.comment;
  }
}
          }
        });
  
        if (isVerifiedForRole) {
          newVerified[index] = true;
        }
        if (isUpdatedForRole) {
          newUpdatedIndexes.push(index);
        }
        if (commentForRole) {
          newComments[item.fieldName] = commentForRole;
        }
          setFieldActions(prev => ({
        ...prev,
        [index]: {
          ...prev[index],
          verified: newVerified[index] || false,
          updated: prev[index]?.updated || false,
          comment: newComments[item?.fieldName] || "",
          updateData: prev[index]?.updateData || {},
          submitted:(newVerified[index])
         
        }
      }));
  
      });
  
      
    }, [existData, roleIdentifier]);


 const handleDirector = async (fieldsToUpdate: any[]) => {
    try {
      if (!fieldsToUpdate || fieldsToUpdate.length === 0) return;
  //  setSubmitLoading(true);
      const payload = {
        couchId: existData?.applicationDataId,
        applicationType: "scheme",
        fieldsToUpdate: fieldsToUpdate
      };

      

      // Call the API
      const response = await queryFormApplication(payload, token);

      if (response?.dbResult?.ok) {
       toast.success(
          <>
            Field updated  successfully <br />
        ક્ષેત્ર સફળતાપૂર્વક અપડેટ થયું
          </>,
          {
            position: "top-right",
        
          }
        ); 
      getExistedApplication();
      } else {
      
      }
        
    } catch (error) {
     
     
    } finally {
    // setSubmitLoading(false)
    }
  };
  // ensure this runs once when required data becomes available
  const autoVerifyDoneRef = useRef(false);

  useEffect(() => {
    // avoid running multiple times
    if (autoVerifyDoneRef.current) return;

    // Wait until we have the data and role info
    if (!existData || !existData.annexureThree || !formFieldDataP3 || !roleIdentifier) return;

    const isDirector = roleIdentifier === "DT";
    const isDistrictRegistrar = roleIdentifier === "Dr";
    if (!isDirector && !isDistrictRegistrar) return;

    const newVerified: { [key: number]: boolean } = {};
    const verifiedFieldsToUpdate: any[] = [];

    // Director should auto-verify fields verified by Deputy Director (DY)
    // District Registrar should auto-verify fields verified by Committee (COM)
    const verifierRoleIdentifier = isDirector ? "DY" : "COM";

    formFieldDataP3.forEach((item, index) => {
      let isVerifiedByPrevious = false;

      item.response.forEach((r) => {
        const transactions = existData.annexureThree?.[r.fieldName]?.transaction || [];

        const prevVerified = transactions.some(
          (tx) => tx.transactionBy === verifierRoleIdentifier && tx.isVerified === true
        );

        if (prevVerified) {
          isVerifiedByPrevious = true;
        }
      });

      if (isVerifiedByPrevious) {
        newVerified[index] = true;

        verifiedFieldsToUpdate.push({
          fieldUpdated: item.fieldName,
          annexureUpdated: "annexureThree",
          newTransaction: {
            transactionBy: userDetail?.Role?.Role_Identifier,
            status: "pending",
            appStatusLevel: existData.appStatusLevel,
            newValue: []
          },
          isVerified: true,
          isUpdated: false,
          comment: ""
        });
      }

      setFieldActions(prev => ({
        ...prev,
        [index]: {
          ...prev[index],
          verified: newVerified[index] || false,
          updated: prev[index]?.updated || false,
          comment: prev[index]?.comment || "",
          updateData: prev[index]?.updateData || {},
          submitted:true
        }
      }));
    });

    if (verifiedFieldsToUpdate.length > 0) {
      handleDirector(verifiedFieldsToUpdate);
    }

    // mark done so it doesn't re-run
    autoVerifyDoneRef.current = true;

    // Run when the data or role become available; but only once because of the ref
  }, [existData, roleIdentifier, formFieldDataP3]);
  return (
    <>
    <div className='w-100 d-flex align-items-end justify-content-end px-5'>
      <div className="w-100">
        <div className='d-flex flex-column text-nightblue align-items-center justify-content-center  '>
                  <div id='table' className='w-100 overflow-hidden bg-white border border-secondary rounded mb-4'>
        
                    <div id='head' className='d-flex w-100  rounded-top border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                        <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                        <h4 className='col-4 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                        <div className='col-7 d-flex justify-content-center align-items-center'>
                          <h4
     className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
  (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))
    ? "col-4"
    : "col-8"
}`}

    >
      જવાબ (Response)
    </h4>

    {(existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ")) && (
      <h4 className="col-4 p-2 justify-content-center d-flex align-items-center border-end border-secondary">
        ક્રિયા (Action)
      </h4>
    )}
      <h4 className="col-4 p-2 justify-content-center d-flex align-items-center  border-secondary">
                  Change History
                </h4>
                        </div>
                    </div>

                  {formFieldDataP3 && formFieldDataP3.length > 0 &&
                    formFieldDataP3.map((item, index) => {
                      if(!item.roles.includes(roleIdentifier)){
                                 return
                        }
           
                     return (

                      

                      <React.Fragment key={index}>
                        {/* Original Field Row */}
                        <div className={`d-flex border-top border-secondary ${(() => {
                            const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
                            if (!fieldName) return '';
                            
                            const annexureField = existData?.annexureThree?.[fieldName];
                            const hasSubmittedUpdates = annexureField?.transaction?.some(
                              (txn) =>( txn?.isUpdated === true && txn?.transactionBy == roleIdentifier)
                              // || txn?.comment.trim() !== ""
                              //For comment to show
                            ) ?? false;
                            
                            return hasSubmittedUpdates ? 'bg-body-tertiary' : '';
                          })()}`}
                          key={index}>
                          <h4 className='col-1 d-flex align-items-center justify-content-center'>{item.fieldNo}</h4>

                          <div className='col-4 border-start border-end border-secondary d-flex align-items-center justify-content-center p-2'>
                            <p>{item.fieldVal}</p>
                          </div>

                          <div className='col-7 d-flex'>
                                             <div className={`col-4 d-flex border-end border-secondary flex-column p-2 gap-2 align-items-center justify-content-center ${
  (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))
    ? "col-4"
    : "col-8"
}`}>
                              {item.response.map((res:any, idx :any) => {
                              
                                if(!res.roles.includes(roleIdentifier)){
                                 return
                                }
                                const fieldName = res.responseVal;
                                const docName = res.responseVal;


                            return (
    <React.Fragment key={`${item.fieldNo}_${res.responseVal}_${idx}`}>
      {res.responseType === "radio" ? radioFn(res?.fieldName) :
       res.responseType === "button" ? fileButtonFn(res?.fieldName, res.responseVal) :
       res.responseType === "file" ? fileFn(res.responseVal) :
       res.responseType === "input" ? inputFn(res.responseVal) :
       res.responseType === "edInput" ? edInputFn(res.responseVal) :
       null}
    </React.Fragment>
  );
                              })}
                            </div>
                      {    (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))&&   <div className='col-4 d-flex p-2 gap-2 flex-column flex-lg-row border-end border-secondary align-items-center justify-content-center'>
                              {
                          <ActionButtons
                          existData={existData}
                          fieldNo={`${index}`} 
                          item={item}
                          fieldActions={fieldActions}
                          editingIndex={editingIndex}
                          setEditingIndex={setEditingIndex}
                          onVerifiedChange={handleVerifiedChange}
                          onCommentChange={handleCommentChange}
                          onUpdateSubmit={handleUpdateSubmit}
                          updatedFields={updatedFields} 
                          annexureType="annexureThree" 
                          userDetail={userDetail}
                          isValidationActive={isValidationActive}
                          hasValidationError={validationErrors[`field_${index}`] || false}
                          fieldIndex={index}
                        />}
                            </div>}
                    <div className='col-4 d-flex p-2 gap-2 flex-column flex-lg-row align-items-center justify-content-center'>
                          {
                      <div className='border rounded-3 ps-2'>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip >
                                See the edit history for this field
                              </Tooltip>
                            }
                          >
                            <i className="feather feather-info pe-2"></i>
                          </OverlayTrigger>
                        {/* {
                          (() => {
                            //  const totalLogs = Object.values(fieldChangeLogs).reduce((sum, logs) => sum + logs.length, 0);
                            const fieldKey = item.response[0]?.responseVal;
                            const logCount = fieldChangeLogs[fieldKey]?.length || 0;
                            return `${logCount} Change${logCount !== 1 ? "s" : ""}`;
                          })()
                        } */}
                       
                        {/* <button
                          className='btn btn-light rounded-3 ms-2'
                          onClick={() =>
                            handleViewLogClick(item.response.map((r) => r.responseVal))
                          }
                          // disabled={changeCount === 0}
                        >
                          View Log
                        </button> */}

                                  {(() => {
        
        const fieldName = item.response.find(r => r?.fieldName)?.fieldName;
        const annexureField = existData?.annexureThree?.[fieldName];

      
        // const hasTransaction = annexureField?.transaction && annexureField.transaction.length > 0;
        const hasValidTransaction =
          annexureField?.transaction?.some(
            (txn) =>
              ( txn?.comment.trim() !== "")
          ) ?? false;

        return (
          <button
            className={`btn rounded-3 ms-2 ${hasValidTransaction ? "btn-primary" : "btn-light"}`}
            onClick={() =>
              handleViewLogClick(
                fieldName
                  ? fieldName
                  : (item.response.find((r) => r?.responseVal)?.responseVal)
              )
            }
          >
            View Log
          </button>
        );
      })()}
                      </div>
                    }
                    </div>
                          </div>
                        </div>

                    {editingIndex === index && ( 
                      <div className="d-flex flex-column border-top border-secondary bg-white p-3">
                        <h4 className="border-bottom border-3 border-success mb-3">Edit Values and Comment</h4>

                        {/* 🔹 Row 1: File Inputs */}
                        <div className="d-flex gap-3 flex-wrap mb-3">
                          {item.response
                            .filter(r => r.responseType === "file" || r.responseType === "button")
                            .map((r, fileIdx) => (
                              <div key={fileIdx} className="d-flex flex-column w-25">
                                <label className="fw-semibold mb-1">
                                  {r.responseName}
                                </label>
                                <input className='form-control w-75' 
                                    type='file'  
                                     onChange={async(e) => {
                                            const response = await  handleFileChange(e, `${r.fieldName}`);
                                             
                                              
                                              if (e.target.files && e.target.files[0] && response) {
                                                
                                                  const updatedDocId=response;

                                                  handleUpdateData(index, {
                                                    ...fieldActions[index]?.updateData,
                                                    [r.fieldName]: {
                                                      docId: updatedDocId, 
                                                      documentName: r.responseVal,
                                                      fileName:e.target.files[0].name
                                                    }
                                                  });
                                              }
                                            }}
                                    name={`${r.responseVal}`}  
                                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                                    id='uploadPlan' 
                                    onBlur={handleBlur}
                                  />
                              </div>
                            ))}
                        </div>

                        {/* 🔸 Row 1.5: Other Input Types */}
                        <div className="d-flex gap-3 flex-wrap mb-3">
                          {item.response
                            .filter(r => r.responseType !== "file" && r.responseType !== "button")
                            .map((r, inputIdx) => {
                              const inputKey = `${item.fieldNo}_${inputIdx}`;
                              const label = r.responseName;

                              switch (r.responseType) {
                                case "input":
                                case "text":
                                  return (
                                    <div key={inputKey} className="d-flex flex-column w-25">
                                      <label className="fw-semibold mb-1">{label}</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={fieldActions[index]?.updateData?.[r.responseVal] || ""}
                                        onChange={(e) =>{  handleInputChange(e)
                                           handleUpdateData(index, {
                                        ...fieldActions[index]?.updateData,
                                        [r.responseVal]: e.target.value
                                      });
                                    }}
                                          name={`${r.responseVal}`}
                                        placeholder="Enter value"
                                      />
                                    </div>
                                  );

                                case "percentage":
                                  return (
                                    <div key={inputKey} className="d-flex flex-column w-25">
                                      <label className="fw-semibold mb-1">{label}</label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        min="0"
                                        max="100"
                                        placeholder="0 - 100"
                                        value={editFieldValues[r.responseVal] || ""}
                                        onChange={(e) => handleEditChange(r.responseVal, e.target.value)}
                                      />
                                    </div>
                                  );

                                case "radio":
                                  return (
                                    <div key={inputKey} className="d-flex flex-column w-25">
                                      <label className="fw-semibold mb-1">{label}</label>
                                      <div className="d-flex gap-3">
                                        <label>
                                          <input
                                            type="radio"
                                             name={`${r.responseVal}`}
                                            value="yes"
                                            checked={fieldActions[index]?.updateData?.[r.responseVal] === "yes"}
                                            onChange={(e) => { handleInputChange(e)
                                               handleUpdateData(index, {
                                        ...fieldActions[index]?.updateData,
                                        [r.responseVal]: e.target.value
                                      });
                                    
                                            }}
                                          />{" "}
                                          Yes
                                        </label>
                                        <label>
                                          <input
                                            type="radio"
                                             name={`${r.responseVal}`}
                                            value="no"
                                            checked={fieldActions[index]?.updateData?.[r.responseVal] === "no"}
                                            onChange={(e) =>{  handleInputChange(e)
                                               handleUpdateData(index, {
                                        ...fieldActions[index]?.updateData,
                                        [r.responseVal]: e.target.value
                                      });
                                    
                                            }}
                                          />{" "}
                                          No
                                        </label>
                                      </div>
                                    </div>
                                  );

                                // Optionally handle "select" or other types
                                default:
                                  return null;
                              }
                            })}
                        </div>

                        {item.fieldNo === "11." && (editFieldValues.hasAssistanceApproved === "yes" || formData.hasAssistanceApproved === "yes") && (
                          <div className="border rounded p-3 mb-3 bg-light">
                            <h5 className="text-info mb-3">Edit Assistance Details</h5>
                            
                            {assistanceDetails.map((block, blockIndex) => (
                              <div key={blockIndex} className="border rounded p-3 mb-3 bg-white">
                                <h6 className="text-primary mb-3">
                                  {['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'][blockIndex]} Detail
                                </h6>
                                
                                <div className="row g-3">
                                  {/* Date Field */}
                                  <div className="col-md-4">
                                    <label className="fw-semibold mb-1">Date *</label>
                                    <input
                                      type="date"
                                      className="form-control"
                                      value={block.date}
                                      onChange={(e) =>
                                        handleAssistanceChange(blockIndex, "date", e.target.value)
                                      }
                                      max="2100-12-31"
                                    />
                                  </div>
                                  
                                  {/* Scheme Field */}
                                  <div className="col-md-4">
                                    <label className="fw-semibold mb-1">Scheme *</label>
                                    <CommonSelect
                                      className="select form-select"
                                      options={scheme}
                                      value={block.scheme ? scheme.find(opt => opt.value === block.scheme) : undefined}
                                      name="scheme"
                                      onChange={(option) =>
                                        handleAssistanceChange(blockIndex, "scheme", option?.value || "")
                                      }
                                      placeholder="Select Scheme"
                                    />
                                  </div>
                                  
                                  {/* Purpose Field */}
                                  <div className="col-md-4">
                                    <label className="fw-semibold mb-1">Purpose *</label>
                                    <CommonSelect
                                      className="select form-select"
                                      options={purposes}
                                      value={block.purpose ? purposes.find(opt => opt.value === block.purpose) : undefined}
                                      name="purpose"
                                      onChange={(option) =>
                                        handleAssistanceChange(blockIndex, "purpose", option?.value || "")
                                      }
                                      placeholder="Select Purpose"
                                    />
                                  </div>
                                  
                                  {/* Sanctioned Amount Field */}
                                  <div className="col-md-6">
                                    <label className="fw-semibold mb-1">Sanctioned Amount *</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Amount"
                                      value={block.sanctionedAmount}
                                      onChange={(e) =>
                                        handleAssistanceChange(blockIndex, "sanctionedAmount", e.target.value)
                                      }
                                    />
                                  </div>
                                  
                                  {/* Action Buttons for each block */}
                                  <div className="col-md-6 d-flex align-items-end gap-2">
                                    {/* Add More (only on last block, max 6) */}
                                    {blockIndex === assistanceDetails.length - 1 && assistanceDetails.length < 6 && (
                                      <button
                                        type="button"
                                        className="btn btn-outline-success btn-sm"
                                        onClick={addAssistanceBlock}
                                      >
                                        <i className="feather feather-plus-circle"></i> Add More
                                      </button>
                                    )}
                                    
                                    {/* Remove (show for all blocks if total > 1) */}
                                    {assistanceDetails.length > 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => removeAssistanceBlock(blockIndex)}
                                      >
                                        <i className="feather feather-trash"></i> Remove
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* 🔻 Row 2: Comment + Submit */}
                        {/* <div className="d-flex w-100 gap-2">
                          <input
                            type="text"
                            className="form-control w-75"
                            placeholder="Comment"
                            value={editComment}
                            onChange={(e) => setEditComment(e.target.value)}
                          />
                          <button
                            className="btn btn-success w-25"
                            onClick={() => handleUpdateSubmit(index, item.response)}
                          >
                            Submit
                          </button>
                        </div> */}
                        
                      </div>
                    )}

                        {/* ✅ INSERT DYNAMIC BLOCK AFTER FIELD 11 */}
                        {item.fieldNo === "11." && formData.hasAssistanceApproved === "yes" && (

                          <React.Fragment key={`assist-block-${item.fieldNo}`}>
                            {assistanceDetails.map((block, index) => (
                              <React.Fragment key={`assist-${index}`}>
                                {/* 🔷 Heading */}
                                <div className="d-flex px-3 border-secondary border-top py-2 bg-light">
                                  <strong>{['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'][index]} Detail</strong>
                                </div>

                                {/* 01. Date */}
                                <div className="d-flex border-secondary">
                                  <h4 className="col-1"></h4>
                                  <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                    <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">01.</h4>
                                    <p className="col-10 p-2 d-flex align-items-center">ક્યારે (Date) *</p>
                                  </div>
                                  <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                    <input
                                      type="date"
                                      className="form-control w-75 m-2"
                                      value={block.date}
                                      onChange={(e) =>
                                        handleAssistanceChange(index, "date", e.target.value)
                                      }
                                      max="2100-12-31"
                                      disabled={true}
                                    />
                                

                                  </div>
                                </div>

                                {/* 02. Scheme / Purpose */}
                                <div className="d-flex border-bottom border-top border-secondary">
                                  <h4 className="col-1"></h4>
                                  <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                    <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">02.</h4>
                                    <p className="col-10 p-2 d-flex align-items-center">યોજના, હેતુ (Scheme, Purpose) *</p>
                                  </div>
                                  <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                           
                                       <input
                                      type="text"
                                      className="form-control w-75 m-2"
                                      value={block.scheme}
                                 
                                      max="2100-12-31"
                                      disabled={true}
                                    />
                                 

                                         <input
                                      type="text"
                                      className="form-control w-75 m-2"
                                      value={block.purpose}
                                 
                                      max="2100-12-31"
                                      disabled={true}
                                    />
                           


                                  </div>
                                </div>

                                {/* 03. Amount */}
                                <div className="d-flex border-bottom border-secondary">
                                  <h4 className="col-1"></h4>
                                  <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                    <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">03.</h4>
                                    <p className="col-10 p-2 d-flex align-items-center">મંજૂર થયેલ રકમ (Sanctioned Amount)*</p>
                                  </div>
                                  <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                    <input
                                      type="text"
                                      className="w-75 m-2 form-control"
                                      placeholder="Enter Amount"
                                      disabled={true}
                                      value={block.sanctionedAmount}
                                      onChange={(e) =>
                                        handleAssistanceChange(index, "sanctionedAmount", e.target.value)
                                      }
                                    />
                            
                                  </div>
                                </div>
                                {/* 04. Amount */}
                            
                                <div className="d-flex  border-secondary px-3 justify-content-end gap-3">
                                  {/* ➕ Add More (only on last block, max 6) */}
                                  {/* {index === assistanceDetails .length - 1 && assistanceDetails .length < 6 && (
                                    <button
                                      className="btn text-info d-flex align-items-center gap-2"
                                      style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 'none' }}
                                      onClick={addAssistanceBlock}
                                    >
                                      <i className="feather feather-plus-circle"></i> Add More
                                    </button>
                                  )} */}

                                  {/* ➖ Remove (show for all blocks if total > 1) */}
                                  {/* {assistanceDetails .length > 1 && (
                                    <button
                                      className="btn text-danger d-flex align-items-center gap-2"
                                      style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 'none' }}
                                      onClick={() => removeAssistanceBlock(index)}
                                    >
                                      <i className="feather feather-trash"></i> Remove
                                    </button>
                                  )} */}
                                </div>



                              </React.Fragment>
                            ))}
                                <div className="d-flex border-bottom border-secondary">
                                  <h4 className="col-1"></h4>
                                  <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
           
                                    <p className="col-10 p-2 d-flex align-items-center">અગાઉ મેળવેલ સહાય અને હાલ સહાય મેળવવા કરેલ અરજીની પ્રોજેકટ કિંમતની રકમ મળી કુલ કેટલી થાય છે ? (Show the detailed information based on records. What is the combined total of the previously received assistance and the current project cost applied for?)*</p>
                                  </div>
                                  <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                    <input
                                      type="text"
                                      className="w-75 m-2 form-control"
                                      placeholder="Enter Amount"
                                      value={formattedTotalSanctioned}
                                      // total is computed from all assistanceDetails.sanctionedAmount
                                      disabled={true}
                                    />
                                 
                                  </div>
                                </div>
                                {/* 05. Amount */}
                                <div className="d-flex border-secondary border-bottom mb-3">
                                  <h4 className="col-1"></h4>
                                  <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                  
                                    <p className="col-10 p-2 d-flex align-items-center">રૂ. ૫ કરોડ કરતા વધુ થાય છે કે કેમ ?( Does it exceed ₹5 crore?)*</p>
                                  </div>
                                  <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                  <div className="d-flex w-75 justify-start gap-2">
                                      <input
                                        type="radio"
                                        name={`hasExceeded5Crore_${index}`}   // 🔹 make unique per block
                                        value="yes"
                                        checked={totalSanctionedAmount > 50000000}
                                        disabled={true}
                                        onChange={(e) => handleAssistanceChange(index, "hasExceeded5Crore", e.target.value)}
                                      /> Yes
                                      <input
                                        type="radio"
                                        name={`hasExceeded5Crore_${index}`}
                                        value="no"
                                        checked={ !(totalSanctionedAmount > 50000000)}
                                        disabled={true}
                                        onChange={(e) => handleAssistanceChange(index, "hasExceeded5Crore", e.target.value)}
                                      /> No
                                    </div>
                                
                                  
                                  </div>
                                </div>
                         
</React.Fragment>
                        )}
 



                      </React.Fragment>
                      
                    )
                    })}

                  </div>
                </div>
   { transaction && transaction.length>0 &&
                              
                              <Link
                              to="#"
                              data-bs-toggle="modal" data-inert={true}
                              data-bs-target="#comment_modal"
                              className="d-flex btn btn-primary align-items-center w-25 mb-4"
                              >
                                  <i className="me-2 ti ti-file-description" />
                                  View Application Timeline
                              </Link>     
                               }
         {  roleIdentifier==="JC"&&               <textarea
                    className="form-control mb-3"
                    placeholder="Enter your comment"
                    name="currAt"
                    value={centralComment!=""? centralComment : ""} // Bind value to state
                    onChange={(e) => setCentralComment(e.target.value)} // Update state on type
                    rows={4} // Adjust number of rows as needed
                    // maxLength={100}
                  />}
    
                {roleIdentifier==="COM" || roleIdentifier==="Dr"?
                <div>
                  <DistrictJCandCOM 
                  apmcName={existData?.department?.apmcName} districtName={existData?.department?.District}
                  issued={issued}
                  certificateData={certificateData} setCertificateData={setCertificateData}
                    agreeTerms={agreeTermsCOM}
                    setAgreeTerms={setAgreeTermsCOM}
                    agreeError={agreeErrorCOM}
                    setAgreeError={setAgreeErrorCOM}
                  />
                </div>:null}
                {issued && (certificateErrors.positionName || certificateErrors.FilledFormName || certificateErrors.projectCapability) && (
                  <div className="mt-2 ms-3">
                    {certificateErrors.positionName && <div className="text-danger small">{certificateErrors.positionName}</div>}
                    {certificateErrors.FilledFormName && <div className="text-danger small">{certificateErrors.FilledFormName}</div>}
                    {certificateErrors.projectCapability && <div className="text-danger small">{certificateErrors.projectCapability}</div>}
                  </div>
                )}
               
                 

        { existData?.appStatusLevel!=="pendingAtDClerk"&&           <div className='gap-3 border p-3 rounded-2 mb-2 bg-white border-secondary'>
   

       
          <p className='p-2 mb-2'>
            સાઇટ નિરીક્ષણ ફોટા(Site Inspection Photos) {roleIdentifier==="COM"&&<span>(Upload multiple photos of the site inspection).*</span>}
          </p>
       

       

           
           { roleIdentifier==="COM" &&existData?.appStatusLevel==="pendingAtCOM"  &&<div  className="d-flex gap-2 align-items-center">
                <input
                  type="file"
                  className="form-control"
                  name="siteInspectionPhoto1"
               
                   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg,.png"  
              
                  onChange={(e) => inspectionPhotosChange(e,"siteInspectionPhoto1")}
                />
                  <input
                  type="file"
                  className="form-control"
               name="siteInspectionPhoto2"
                    accept=".pdf, .jpeg,.png, .jpg, application/pdf, image/jpeg"  
              
                  onChange={(e) => inspectionPhotosChange(e,"siteInspectionPhoto2")}
                />
                  <input
                  type="file"
                  className="form-control"
               name="siteInspectionPhoto3"
                  accept=".pdf, .jpeg,.png, .jpg, application/pdf, image/jpeg"  
              
                  onChange={(e) => inspectionPhotosChange(e,"siteInspectionPhoto3")}
                />
                  <input
                  type="file"
                  className="form-control"
               name="siteInspectionPhoto4"
               accept=".pdf, .jpeg, .png,.jpg, application/pdf, image/jpeg"  
              
                  onChange={(e) => inspectionPhotosChange(e,"siteInspectionPhoto4")}
                />
                
             
              </div>}
         {existData?.appStatusLevel !== "pendingAtCOM" && 
  existData?.siteInspectionPhotos &&
<div  className="d-flex gap-2 align-items-center">
{Object.values(existData.siteInspectionPhotos).map((doc: any, index: number) => (
  <React.Fragment key={doc.docId || index}>
    <span className="me-2">Photo {index + 1}:</span>

    <div className="mt-2">
      <Link
        to="#"
        data-bs-toggle="modal"
        data-inert={true}
        data-bs-target="#apmc_modal"
        className="btn btn-outline-info w-100 align-items-center"
        onClick={() => {
          setSelectedDocId(doc?.docId);
        }}
      >
        <i className="ti ti-eye"></i> View Document
      </Link>
    </div>
  </React.Fragment>
))}

  </div>
}
       
      </div>}
  {roleIdentifier!=="JC"&&<div className="d-flex justify-content-end gap-2 mb-3 me-5">
    
      <button className="btn btn-secondary" onClick={onBack}>Back</button>
      <button className="btn btn-info" onClick={handleSubmit}>Next</button>
    </div>}
               {!["Dr", "HOS", "DT", "DY", "SC","COM","SA"].includes(roleIdentifier)  &&
                    <div className="d-flex justify-content-end gap-2 mb-4 me-5">
                        {existData.buttonName && existData?.buttonName.map((button: any) => (
                            <button
                                key={button.status}
                                type="button"
                                className={`btn ${button.status === "reject"
                                    ? "btn-danger"
                                    : button.status === "permanentReject" ? "btn-secondary" : "btn-success"
                                    } ms-1`}
                                onClick={() => handleFinalSubmit(button.status, button.appStatusLevel)}
                            >
                                {button.buttonLabel}
                            </button>
                        ))}
                    </div>
                }
        </div>
        </div>

      {showLogOverlay && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 1055 }}
        >
          <div
            className="bg-white p-4 rounded shadow position-relative overflow-auto"
            style={{ minWidth: "70%", maxHeight: "90%", maxWidth: "800px" }}
          >
            <button
              className="position-absolute top-0 end-0 m-3 btn-close"
              onClick={handleCloseOverlay}
            />
     
            <div className="d-flex align-items-center gap-2 mb-3">
              <i className="ti ti-history"></i>
              <h4 className="mb-0">Change History -{formFieldDataP3.find((f: any) => f.fieldName === logFieldKey)?.fieldLabel || logFieldKey}</h4>
            </div>
     
            {/* Transaction Section */}
            {
            transactionData?.length > 0 &&
             (
              <div className="mt-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="ti ti-report"></i>
                  <h5 className="mb-0">Transaction History</h5>
                </div>
     
                {transactionData.map((txItem, idx) => (
                  <div key={idx} className="mb-4">
                    <div className="badge bg-info mb-2">{formFieldDataP3.find((f: any) => f.fieldName === txItem.key)?.fieldLabel || txItem.key}</div>
     
                    {txItem.data.length === 0 ? (
                      <div className="text-muted">No transaction found.</div>
                    ) : (
                      txItem.data.map((entry, i) => (
                        <div
                          key={i}
                          className="border-start border-info border-3 p-3 mb-3 bg-light-subtle rounded"
                        >
                          <div className="d-flex justify-content-between align-items-center mb-2">
                             <strong>Modified By:   {(() => {
                                                                                                 const role = roleOptions.find(
                                                                                                   (option) => option.value === entry.transactionBy
                                                                                                 );
                                                                                              
                                                                                                 return role?.label || "Unknown";
                                                                                               })()}</strong>
                            <small className="text-muted">📅 {entry.createdAt || "-"}</small>
                          </div>
                          {entry.oldValue.length > 0 && entry.newValue.length > 0 && <div className="d-flex align-items-center gap-2 mb-2">
                            <span className="text-danger">Old Data:</span>
                            <div className="d-flex flex-column gap-1">
                                {Array.isArray(entry.oldValue) ? (
                                  entry.oldValue.map((item, i) =>
                                    typeof item === "object" && item.fieldType === "doc" ? (
                                      <div key={i} className="d-flex align-items-center gap-2">
                                       <span className="badge bg-secondary">{responseMap[item?.fieldName]}</span>
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-inert={true}
                                          data-bs-target="#apmc_modal"
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() => setSelectedDocId(item.fieldValue)}
                                        >
                                          <i className="ti ti-eye"></i> View Document
                                        </Link>
                                      </div>
                                    ) : (
                                      <span key={i} className="badge bg-danger-subtle text-danger">
                                        {typeof item === "object" ? item.fieldValue : item}
                                      </span>
                                    )
                                  )
                                ) : (
                                  <span className="badge bg-danger-subtle text-danger">{entry.oldValue.fieldValue}</span>
                                )}
                              </div>
                            <i className="ti ti-arrow-right"></i>
                            <span className="text-danger">Updated Data:</span>
     
                             <div className="d-flex flex-column gap-1">
                                {Array.isArray(entry.newValue) ? (
                                  entry.newValue.map((item, i) =>
                                    typeof item === "object" && item.fieldType === "doc" ? (
                                      <div key={i} className="d-flex align-items-center gap-2">
                                      <span className="badge bg-secondary">{responseMap[item?.fieldName]}</span>
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-inert={true}
                                          data-bs-target="#apmc_modal"
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() => setSelectedDocId(item.fieldValue)}
                                        >
                                          <i className="ti ti-eye"></i> View Document
                                        </Link>
                                      </div>
                                    ) : (
                                      <span key={i} className="badge bg-danger-subtle text-danger">
                                        {typeof item === "object" ? item.fieldValue : item}
                                      </span>
                                    )
                                  )
                                ) : (
                                  <span className="badge bg-danger-subtle text-danger">{entry.newValue.fieldValue}</span>
                                )}
                              </div>
                          </div>}
                          <div className="d-flex align-items-center gap-2 mb-2">
                            <span className="text-muted">Status:</span>
                            <span className="badge bg-warning-subtle text-dark fs-14">
                              {entry.status}
                            </span>
                          </div>
                          
                          {/* Show verification status if available */}
                          {entry.isVerified !== undefined &&  (
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <span className="text-muted">Verified:</span>
                              <span className={`badge ${entry.isVerified ? 'bg-success' : 'bg-secondary'}`}>
                                {entry.isVerified ? 'Yes' : 'No'}
                              </span>
                            </div>
                          )}

                          {entry.comment && (
                            <div className="bg-primary-subtle text-dark rounded p-2 d-flex align-items-start gap-2">
                              <i className="ti ti-message mt-1"></i>
                              <span>{entry.comment}</span>
                            </div>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      <SingleView docId={selectedDocId} type="Scheme"/>
      <ApplicationTimelineModal comments={transaction} />
    </>
  )
}

export default DistP3

